// src/pages/orders/LoungeOrderHistory.jsx
import React from 'react';
import OrderHistory from '../Waiters_OrderHistory';

const LoungeOrderHistory = () => {
  return <OrderHistory locationKey="lounge" />;
};

export default LoungeOrderHistory;